import axios from '@axios'

const route = 'report/occupancy_movemment'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, filter) {
      return axios.post(route, filter)
    },

    exportExcel(context, filter) {
      return axios.post(`${route}/export_excel`, filter, { responseType: 'blob' })
    },
    exportPdf(context, filter) {
      return axios.post(`${route}/export_pdf`, filter, { responseType: 'blob' })
    },
  },
}
